import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Common from "../based/Common";
import { NOTIFY, PAYMENT_METHOD } from "../based/Constants";
import Radio from "../based/inputs/Radio";
import { Notify } from "../based/Notify";
import { RequestDomain } from "../based/RequestDomain";
import OrderServices from "../based/services/OrderServices";
import Cart from "./assets/Cart.svg";
import CopyOrange from "./assets/CopyOrange.svg";
import Location from "./assets/Location.svg";
import Money from "./assets/Money.svg";
import RanusLogo from "./assets/RanusLogo.png";
import CartItem from "./CartItem";

function TempBillSlide({ checkoutReadyId, show, onClose, onCreateLink, readyModel, onSentFacebook }) {
    const [model, setModel] = useState({});
    const refModal = useRef();

    //click outside to close
    useEffect(() => {
        const handleOutside = (e) => {
            if (refModal.current && !refModal.current.contains(e.target)) {
                // close modal
                onClose();
            }
        };
        window.addEventListener("click", handleOutside);
        return () => {
            window.removeEventListener("click", handleOutside);
        };
    }, []);

    useEffect(() => {
        if (checkoutReadyId > 0) {
            getData(checkoutReadyId);
        }
    }, [checkoutReadyId]);

    const getData = async (readyListId) => {
        const [err, data] = await OrderServices.GetOrderReadyConfirmByReadyListId(readyListId);
        if (!err && data) {
            setModel(data);
        } else {
            setModel({});
        }
    };

    return (
        <TotalWrapper>
            <div className={`background ${show ? "show" : "d-none"}`}></div>
            <Wrapper className={`${show ? "show" : "d-none"}`}>
                <section className="total" ref={refModal}>
                    <section className="wrapper-desktop">
                        <section className="header">
                            <h4>Bill tạm tính</h4>
                        </section>
                        <section className="bill-body">
                            <section className="logo-section">
                                <div className="icon">
                                    <img src={RanusLogo} alt="Ranus Logo" />
                                </div>
                            </section>
                            {model.orderShipping && (
                                <section className="address">
                                    <h6 className="address-header">
                                        <div className="icon">
                                            <img src={Location} />
                                        </div>
                                        Giao hàng đến
                                    </h6>
                                    <div className="address-body">
                                        <div className="address-name">
                                            <span>{model.orderShipping.userName}</span>
                                            <span className="break"></span>
                                            <span>{model.orderShipping.phoneNumber}</span>
                                        </div>
                                        <div className="address-location">
                                            <span>{model.orderShipping.fullAddress}</span>
                                        </div>
                                    </div>
                                </section>
                            )}

                            <section className="payment">
                                <div className="payment-header">
                                    <h6>
                                        <div className="icon">
                                            <img src={Money} alt="" />
                                        </div>
                                        Chi tiết thanh toán
                                    </h6>
                                </div>
                                <div className="payment-left">
                                    <div className="payment-body">
                                        <div className="payment-detail-item">
                                            <div className="payment-detail-item-left">Tạm tính ({model.itemCounts} sản phẩm)</div>
                                            <div className="payment-detail-item-right">{Common.formatCurrency(model.totalPrice)}</div>
                                        </div>
                                        <div className="payment-detail-item">
                                            <div className="payment-detail-item-left">Phí vận chuyển</div>
                                            <div className="payment-detail-item-right">0đ</div>
                                        </div>
                                        <div className="payment-detail-item">
                                            <div className="payment-detail-item-left">Voucher Daily</div>
                                            <div className="payment-detail-item-right">{Common.formatCurrency(model.totalDiscount)}</div>
                                        </div>
                                        {model.totalCampaign > 0 && (
                                            <div className="payment-detail-item">
                                                <div className="payment-detail-item-left">Chương trình giảm giá</div>
                                                <div className="payment-detail-item-right">{Common.formatCurrency(model.totalCampaign)}</div>
                                            </div>
                                        )}
                                        <hr />
                                        <div className="payment-detail-item">
                                            <div className="payment-detail-item-left">Tổng tiền thanh toán</div>
                                            <div className="payment-detail-item-right finnaly-price">{Common.formatCurrency(model.finallyPrice)}</div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section className="cart">
                                <div className="cart-header">
                                    <h6>
                                        <div className="icon">
                                            <img src={Cart} alt="" />
                                        </div>
                                        Thông tin sản phẩm
                                    </h6>
                                    <div className="product-count">{`${model.itemCounts} sản phẩm`}</div>
                                </div>
                                <div className="cart-body">
                                    {model.orderCustomizeProducts &&
                                        model.orderCustomizeProducts.length > 0 &&
                                        model.orderCustomizeProducts.map((item, idx) => {
                                            return (
                                                <div className="cart-item">
                                                    <div className="cart-item-image">
                                                        <CartItem groupDesignId={item.groupDesignId} itemWidth={100} />
                                                    </div>
                                                    <div className="cart-item-info">
                                                        <div className="product-name">
                                                            <span>{item.designName}</span>
                                                        </div>
                                                        <div className="product-attribute">
                                                            <span>
                                                                {item.appProductName}, {item.color}
                                                            </span>
                                                        </div>
                                                        <div className="product-list">
                                                            <span>
                                                                {item.size} x {item.quantity}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </section>
                        </section>
                    </section>
                    <section className="payment-method">
                        <div className="payment-select">
                            <div className="payment-select-header">
                                <h6>Chọn phương thức thanh toán</h6>
                            </div>
                            <div className="payment-select-body">
                                <div className="section-pre-payment">
                                    <h6>Thanh toán trước</h6>
                                    <div className="list-payment">
                                        <div className="payment">
                                            <Radio
                                                label="MoMo"
                                                name="MoMo"
                                                checked={model.paymentMethod == PAYMENT_METHOD.MOMO_WALLET}
                                                onCheckedChange={(name, value) => {
                                                    setModel({ ...model, paymentMethod: PAYMENT_METHOD.MOMO_WALLET });
                                                }}
                                            />
                                        </div>
                                        <div className="payment">
                                            <Radio
                                                label="Ngân hàng"
                                                name="InternetBanking"
                                                checked={model.paymentMethod == PAYMENT_METHOD.INTERNET_BANKING}
                                                onCheckedChange={(name, value) => {
                                                    setModel({ ...model, paymentMethod: PAYMENT_METHOD.INTERNET_BANKING });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="section-pre-payment">
                                    <h6>Đặt cọc</h6>
                                    <div className="list-payment">
                                        <div className="payment">
                                            <Radio
                                                label="Ngân hàng"
                                                name="COD_TO_TRANSFER"
                                                checked={model.paymentMethod == PAYMENT_METHOD.COD_TO_TRANSFER}
                                                onCheckedChange={(name, value) => {
                                                    setModel({ ...model, paymentMethod: PAYMENT_METHOD.COD_TO_TRANSFER });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="section-pre-payment">
                                    <h6>Thanh toán khi nhận hàng</h6>
                                    <div className="list-payment">
                                        <div className="payment">
                                            <Radio
                                                label="COD"
                                                name="COD"
                                                checked={model.paymentMethod == PAYMENT_METHOD.COD}
                                                onCheckedChange={(name, value) => {
                                                    setModel({ ...model, paymentMethod: PAYMENT_METHOD.COD });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {model.readyId > 0 && (
                                    <TotalWrapper>
                                        <hr />
                                        <div className="section-pre-payment">
                                            <div className="header-pre-payment">
                                                <h6>Link giỏ hàng</h6>
                                                <div
                                                    className="copy-icon cursor-pointer"
                                                    onClick={(e) => {
                                                        navigator.clipboard.writeText(`${RequestDomain.HomeUrl()}/checkout-ready/${model.readyId}?paymentMethod=${model.paymentMethod}`);
                                                        Notify(NOTIFY.SUCCESS, "Copy", "Đã copy link giỏ hàng");
                                                    }}
                                                >
                                                    <div className="icon">
                                                        <img src={CopyOrange} alt="" />
                                                    </div>
                                                    <span>Copy</span>
                                                </div>
                                            </div>
                                            <div
                                                className="text-area-input cursor-pointer"
                                                onClick={(e) => {
                                                    navigator.clipboard.writeText(`${RequestDomain.HomeUrl()}/checkout-ready/${model.readyId}?paymentMethod=${model.paymentMethod}`);
                                                    Notify(NOTIFY.SUCCESS, "Copy", "Đã copy link giỏ hàng");
                                                }}
                                            >
                                                <textarea rows={2} value={`${RequestDomain.HomeUrl()}/checkout-ready/${model.readyId}?paymentMethod=${model.paymentMethod}`} readOnly />
                                            </div>
                                        </div>
                                    </TotalWrapper>
                                )}
                            </div>
                            {model.readyId == 0 ? (
                                <div
                                    className="bottom-btn"
                                    onClick={(e) => {
                                        if (onCreateLink) {
                                            onCreateLink();
                                        }
                                    }}
                                >
                                    <button>Tạo link giỏ hàng</button>
                                </div>
                            ) : (
                                model.facebookId != "" &&
                                model.facebookId != null && (
                                    <div
                                        className="bottom-sent"
                                        onClick={(e) => {
                                            if (onSentFacebook) {
                                                let url = `${RequestDomain.HomeUrl()}/checkout-ready/${model.readyId}?paymentMethod=${model.paymentMethod}`;
                                                onSentFacebook(url);
                                            }
                                        }}
                                    >
                                        <button>Gửi qua Facebook</button>
                                    </div>
                                )
                            )}
                        </div>
                    </section>
                </section>
            </Wrapper>
        </TotalWrapper>
    );
}

export default TempBillSlide;

const TotalWrapper = styled.div`
    .background {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: black;
        opacity: 0.4;
    }
`;

const Wrapper = styled.div`
    .bottom-sent button {
        border-radius: 30px;
        background: #2673dd;
        border: none;
        width: 100%;
        padding: 10px;
        color: #fff;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .header-pre-payment {
        display: flex;
        align-items: center;
    }

    .copy-icon {
        margin-left: auto;
        display: flex;
        align-items: center;
        color: #ff9027;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .copy-icon .icon {
        display: flex;
        margin-right: 6px;
    }

    .text-area-input textarea {
        width: 100%;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 9px 12px;
    }

    .payment-select {
        border-radius: 12px;
        border: 1px solid #e5e5e5;
        background: #fff;
        margin: 100px 20px;
        padding: 24px;
    }

    .payment-select-header h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .section-pre-payment h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .bottom-btn button {
        border-radius: 30px;
        background: #ff9027;
        color: #fff;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        border: none;
        width: 100%;
        padding: 6px;
    }

    .bottom-btn {
        margin: 12px 0;
    }

    .radio label {
        color: #707070;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .list-payment {
        display: flex;
        align-items: center;
    }

    .section-pre-payment .payment {
        display: flex;
        align-items: center;
        margin: 0 6px;
    }

    background: white;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    width: 900px;
    z-index: 999;
    display: flex;

    .header h4 {
        color: #303030;
        font-family: Lexend;
        font-size: 25px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    section.bill-body {
        background: linear-gradient(180deg, rgba(242, 14, 69, 0.1), rgba(242, 14, 69, 0) 100%);
    }

    section.logo-section {
        display: flex;
        justify-content: center;
    }

    section.address {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        margin: 12px 30px;
        padding: 12px;
    }

    h6.address-header {
        display: flex;
        align-items: center;
        margin: 6px 0;
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .address-header .icon {
        display: flex;
        margin-right: 6px;
    }

    .address-name {
        display: flex;
        align-items: baseline;
        overflow: hidden;
        color: #303030;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    span.break {
        width: 2px;
        height: 100%;
        background-color: #303030;
        margin: 0 20px;
        padding: 5px 0;
    }

    .address-location {
        overflow: hidden;
        color: #303030;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 6px 0;
    }

    section.payment {
        margin: 16px 30px;
    }

    .payment-header {
        /* display: flex; */
        /* align-items: center; */
        /* color: #303030; */
        /* font-family: Lexend; */
        /* font-size: 20px; */
        /* font-style: normal; */
        /* font-weight: 600; */
        /* line-height: normal; */
    }

    .payment-header h6 {
        display: flex;
        align-items: center;
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .payment-header h6 .icon {
        display: flex;
        margin-right: 6px;
    }

    section.payment-internet {
        display: flex;
    }

    .payment-internet .header {
        display: flex;
    }

    .payment-internet .header .header-icon {
        display: flex;
        align-items: center;
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .payment-detail-item {
        display: flex;
        align-items: center;
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 5px 0;
    }

    .payment-internet .header .header-icon .icon {
        display: flex;
        margin-right: 6px;
    }

    .payment-detail-item-right {
        margin-left: auto;
    }

    .payment-detail-item-right.finnaly-price {
        color: #f20e45;
        text-align: right;
        font-family: Lexend;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .cart-header h6 {
        display: flex;
        align-items: center;
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .cart-header h6 .icon {
        display: flex;
        margin-right: 6px;
    }

    section.cart {
        margin: 16px 30px;
    }

    .cart-header {
        display: flex;
        align-items: center;
    }

    .product-count {
        margin-left: auto;
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .cart-item {
        display: flex;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 8px;
    }

    .cart-item-image {
        display: flex;
        align-items: center;
    }

    .list-image {
        display: flex;
        align-items: center;
    }

    .cart-item-info {
        flex: 1;
        margin-left: 12px;
    }

    .product-name {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .product-attribute {
        overflow: hidden;
        color: #a0a0a0;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 8px 0;
    }

    section.total {
        flex: 1;
        display: flex;
    }

    section.wrapper-desktop {
        width: 60%;
    }

    section.payment-method {
        flex: 1;
    }
`;
